import React from 'react';
import { Document } from '@contentful/rich-text-types';

import { useYotpoScript } from '@/hooks/useYotpoScript';
import { RichText } from '@/components';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import { YotpoReviewStars } from '@/components/ui/YotpoReviewStars';
import { shouldUseYotpoReviews } from '@/utils/helpers';
import { TypeExploreByKitsFields } from '@/core/generated-types';
import {
  YOTPO_PLAYKIT_PROGRAM_PRODUCT_IDS,
  getShopifyDomain,
} from '@/core/constants';

import { ExplorerSlice } from '../ExplorerSlice';

const ExploreThePlayKits = ({
  title,
  anchorId,
  secondaryText,
  slices,
}: TypeExploreByKitsFields) => {
  useYotpoScript();
  const shopifyProductID =
    YOTPO_PLAYKIT_PROGRAM_PRODUCT_IDS[getShopifyDomain()];

  return (
    <div className="mx-auto max-w-[1128px] px-6 lg:px-0">
      <div
        data-testid={anchorId}
        id={anchorId}
        className="relative -top-[90px] md:h-[10px]"
      />
      <div className="flex justify-center pt-8 lg:pt-[70px]">
        <div>
          <Heading
            tag={HeadingTag.H2}
            size={HeadingSize.H2}
            classes="text-charcoal-dark"
            align="center"
            text={title}
            hoverEffect
          />

          {shouldUseYotpoReviews() && shopifyProductID && (
            <div className="plp-reviews-summary flex justify-center lg:!my-5">
              <YotpoReviewStars productID={shopifyProductID} />
            </div>
          )}
          {secondaryText && (
            <div className="text-center whitespace-pre-wrap leading-6 lg:text-xl lg:mt-3">
              <RichText content={secondaryText as Document} />
            </div>
          )}
          <div className="mt-5 -mb-8 lg:mt-9 lg:-mb-16">
            {slices &&
              slices?.map(({ fields: slice }: any) => (
                <ExplorerSlice key={slice.anchorId} {...slice} />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreThePlayKits;
